import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const CashMoneyIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.259001 9.52448C0.0547532 9.5997 -0.0505249 9.8261 0.0238785 10.0311L0.272471 10.7151L2.16529 8.82227L0.259001 9.52448Z"
        fill="currentColor"
      />
      <path
        d="M2.05051 15.6045L3.19049 18.7395C3.22612 18.8384 3.30052 18.9192 3.39552 18.9627C3.44855 18.9872 3.50555 18.9999 3.56255 18.9999C3.60927 18.9999 3.65517 18.992 3.69952 18.9754L4.95747 18.5115L2.05051 15.6045Z"
        fill="currentColor"
      />
      <path
        d="M18.9761 12.9278L17.6715 9.34082L14.5405 12.4718L16.0921 11.9002C16.2956 11.8226 16.5252 11.9287 16.6004 12.1346C16.6764 12.3396 16.5711 12.5676 16.366 12.6428L14.3948 13.3696C14.3497 13.3862 14.3038 13.3941 14.2579 13.3941C14.0971 13.3941 13.9451 13.2951 13.8866 13.1352C13.8858 13.1328 13.8866 13.1305 13.8858 13.1281L10.568 16.4459L18.741 13.4345C18.946 13.3593 19.0513 13.1328 18.9761 12.9278Z"
        fill="currentColor"
      />
      <path
        d="M18.8843 6.44905L12.5511 0.11578C12.3967 -0.0385933 12.1457 -0.0385933 11.9913 0.11578L0.116482 11.9906C-0.0378914 12.145 -0.0378914 12.396 0.116482 12.5504L6.44975 18.8836C6.52653 18.9612 6.62788 19 6.72922 19C6.83056 19 6.93187 18.9612 7.00947 18.8844L18.8843 7.00954C19.0387 6.85439 19.0387 6.6042 18.8843 6.44905ZM4.63449 10.9678L3.05117 12.5511C2.97357 12.6279 2.87227 12.6667 2.77092 12.6667C2.66958 12.6667 2.56827 12.6279 2.49067 12.5511C2.3363 12.3968 2.3363 12.1458 2.49067 11.9914L4.074 10.4081C4.22837 10.2537 4.47934 10.2537 4.63372 10.4081C4.78809 10.5625 4.78887 10.8127 4.63449 10.9678ZM11.4704 11.4705C11.1902 11.7508 10.8094 11.8854 10.3859 11.8854C9.68602 11.8854 8.86825 11.5188 8.18426 10.834C7.68392 10.3337 7.33243 9.7352 7.19549 9.14939C7.0435 8.49628 7.16859 7.92788 7.54777 7.54788C7.92699 7.16789 8.49538 7.04279 9.14928 7.19561C9.73512 7.33258 10.3336 7.68326 10.8339 8.18438C11.9336 9.28317 12.2138 10.7272 11.4704 11.4705ZM16.5094 7.00954L14.926 8.59287C14.8484 8.66965 14.7471 8.70847 14.6458 8.70847C14.5444 8.70847 14.4431 8.66969 14.3655 8.59287C14.2112 8.4385 14.2112 8.18753 14.3655 8.03316L15.9489 6.44983C16.1032 6.29546 16.3542 6.29546 16.5086 6.44983C16.6629 6.6042 16.6637 6.85439 16.5094 7.00954Z"
        fill="currentColor"
      />
    </svg>
  )
})

CashMoneyIcon.displayName = 'CashMoneyIcon'
